import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<input type="range" class="svelte-1dhg3t6lk0w5k"/>`);
var root_1 = $.from_html(`<div class="row svelte-1dhg3t6lk0w5k"><div class="meta svelte-1dhg3t6lk0w5k" title="Double-click to reset"><span class="label svelte-1dhg3t6lk0w5k"> </span> <span class="value svelte-1dhg3t6lk0w5k"> </span></div> <!></div>`);

export default function Slider($$anchor, $$props) {
	$.push($$props, true);

	const decimals = $.derived(() => ($$props.spec.step.toString().split(".")[1] ?? "").length);
	const shown = $.derived(() => $$props.value.toFixed($.get(decimals)) + ($$props.spec.unit ?? ""));

	// Log-scale sliders map the track position [0..1000] exponentially onto
	// [min..max] (min must be > 0); linear sliders use the native mapping.
	const isLog = $.derived(() => $$props.spec.scale === "log");

	const POS_MAX = 1000;

	function toPos(v) {
		return Math.round(POS_MAX * Math.log(v / $$props.spec.min) / Math.log($$props.spec.max / $$props.spec.min));
	}

	function fromPos(pos) {
		const raw = $$props.spec.min * Math.pow($$props.spec.max / $$props.spec.min, pos / POS_MAX);
		const snapped = Math.round((raw - $$props.spec.min) / $$props.spec.step) * $$props.spec.step + $$props.spec.min;

		return Math.min($$props.spec.max, Math.max($$props.spec.min, snapped));
	}

	var div = root_1();
	var div_1 = $.child(div);
	var span = $.child(div_1);
	var text = $.child(span, true);

	$.reset(span);

	var span_1 = $.sibling(span, 2);
	var text_1 = $.child(span_1, true);

	$.reset(span_1);
	$.reset(div_1);

	var node = $.sibling(div_1, 2);

	{
		var consequent = ($$anchor) => {
			var input = root();

			$.remove_input_defaults(input);
			$.set_attribute(input, 'min', 0);
			$.set_attribute(input, 'max', POS_MAX);
			$.set_attribute(input, 'step', 1);

			$.template_effect(
				($0) => {
					$.set_value(input, $0);
					$.set_attribute(input, 'aria-label', $$props.spec.label);
					$.set_attribute(input, 'aria-valuetext', $.get(shown));
				},
				[() => toPos($$props.value)]
			);

			$.delegated('input', input, (e) => $$props.onchange(fromPos(Number(e.currentTarget.value))));

			$.delegated('dblclick', input, function (...$$args) {
				$$props.onreset?.apply(this, $$args);
			});

			$.append($$anchor, input);
		};

		var alternate = ($$anchor) => {
			var input_1 = root();

			$.remove_input_defaults(input_1);

			$.template_effect(() => {
				$.set_attribute(input_1, 'min', $$props.spec.min);
				$.set_attribute(input_1, 'max', $$props.spec.max);
				$.set_attribute(input_1, 'step', $$props.spec.step);
				$.set_value(input_1, $$props.value);
				$.set_attribute(input_1, 'aria-label', $$props.spec.label);
			});

			$.delegated('input', input_1, (e) => $$props.onchange(Number(e.currentTarget.value)));

			$.delegated('dblclick', input_1, function (...$$args) {
				$$props.onreset?.apply(this, $$args);
			});

			$.append($$anchor, input_1);
		};

		$.if(node, ($$render) => {
			if ($.get(isLog)) $$render(consequent); else $$render(alternate, -1);
		});
	}

	$.reset(div);

	$.template_effect(() => {
		$.set_text(text, $$props.spec.label);
		$.set_text(text_1, $.get(shown));
	});

	$.delegated('dblclick', div_1, function (...$$args) {
		$$props.onreset?.apply(this, $$args);
	});

	$.append($$anchor, div);
	$.pop();
}

$.delegate(['dblclick', 'input']);
import "bun-svelte:Slider.svelte-22r68qxonmys2-style.css";